/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttributeGroupsAg } from '../../models/attribute-groups-ag';

export interface GetAttributeGroups$Params {
  orid: number;
}

export function getAttributeGroups(http: HttpClient, rootUrl: string, params: GetAttributeGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AttributeGroupsAg>>> {
  const rb = new RequestBuilder(rootUrl, getAttributeGroups.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttributeGroupsAg>>;
    })
  );
}

getAttributeGroups.PATH = '/api/AttributeGroups/getAttributeGroups/{orid}';
